var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('reminder-table',{attrs:{"resource-name":"project","resource-id":_vm.projectData.id},on:{"refetch-data":function($event){return _vm.emit('refetch-data')}}})}
var staticRenderFns = []

export { render, staticRenderFns }